import React from 'react';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useBool } from '@domain/hooks/use.bool';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { ButtonGroup } from '@material-ui/core';
import { ButtonInsertNote } from '@screens/players/player.details.tabs/notes/button.insert.note';
import PlayerNoteInsert from '@screens/players/player.details.tabs/notes/player.note.insert';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { useAuth } from '@domain/auth/auth.hook';
import { GridColumns } from '@material-ui/data-grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';

const columns: GridColumns = [
  { field: 'id', headerName: 'Id', width: 108 },
  { field: 'timeStamp', headerName: 'Timestamp', ...formatColWithDate, width: 149 },
  { field: 'moderator', headerName: 'Moderator', width: 149 },
  { field: 'category', headerName: 'Category', width: 149 },
  { field: 'content', headerName: 'Note', width: 640 },
];

interface Notes {
  noteId: number;
  count: number;
}
let index = 0;

function createData(note: Notes) {
  index += 1;
  return { id: index, ...note };
}

const PlayerNotes = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  const insertNoteOpen = useBool(false);

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<Notes[]>(`/admin/box-note/list/${requestPid}`, { params: { page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];

  return (
    <>
      <ButtonGroup variant='contained' aria-label='Player actions' color='primary'>
        <ButtonInsertNote disabled={loading} onClick={insertNoteOpen?.toggle} />
      </ButtonGroup>
      <PlayerNoteInsert player={player} open={insertNoteOpen} />
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PlayerNotes;
